import React from 'react';
import Relay from 'react-relay';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage, IntlShape } from 'react-intl';
import AppPanel from '../fw/AppPanel.react';
import TestResultsTable from './TestResultsTable';
import types from '../../common/model-api/types';

interface FlowTestResultsViewProps {
    intl: IntlShape;
    user: {
        testInvocations: any;
    };
    params: {
        flowId: string;
        organisationId: string;
    };
    relay: any;
}

class FlowTestResultsView extends React.Component<FlowTestResultsViewProps> {
    static propTypes = {
        intl: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    refreshData = () => {
        this.props.relay.forceFetch();
    };

    render() {
        const { flowId } = this.props.params;
        const { testInvocations } = this.props.user;
        const list = testInvocations ? testInvocations.edges.map(e => e.node) : [];

        // Mock breadcrumbs for now as we don't have the full Relay user object here
        const breadcrumbParams = [
            { type: types['organisations'], data: { realId: this.props.params.organisationId, id: this.props.params.organisationId, name: 'Organisation' } },
            { type: types['flows'], data: { realId: flowId, id: flowId, name: 'Flow' } },
        ];

        return (
            <AppPanel
                breadcrumbParams={breadcrumbParams}
                title={this.props.intl.formatMessage({ id: 'snapshotTesting.pageTitle', defaultMessage: 'Flow Test Results' })}
            >
                <div className="flex-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1em' }}>
                    <h3>
                        <i className="fa fa-flask" /> <FormattedMessage defaultMessage="Test Results for Flow" id="snapshotTesting.resultsTitleFlow" />
                    </h3>
                    <button className="btn btn-default" onClick={this.refreshData}>
                        <i className="fa fa-refresh" /> <FormattedMessage defaultMessage="Refresh" id="common.refresh" />
                    </button>
                </div>

                <TestResultsTable invocations={list} onRerun={this.refreshData} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(injectIntl(FlowTestResultsView), {
    initialVariables: {
        flowId: null,
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                testInvocations(flowId: $flowId, first: 1000) {
                    edges {
                        node {
                            id
                            realId
                            name
                            organisation_id
                            flow_id
                            sourceFlowInvocation_id
                            lastStatus
                            lastRunAt
                            lastDuration
                            lastError
                            lastSuccessfulRun {
                                id
                                realId
                                status
                                duration
                                createdAt
                            }
                            lastUnsuccessfulRun {
                                id
                                realId
                                status
                                duration
                                createdAt
                                error
                            }
                            runs(first: 50) {
                                edges {
                                    node {
                                        id
                                        realId
                                        status
                                        duration
                                        createdAt
                                        error
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `,
    },
});
